import { render, staticRenderFns } from "./termsOfUse.vue?vue&type=template&id=06454c48&"
import script from "./termsOfUse.vue?vue&type=script&lang=js&"
export * from "./termsOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports